<template>
  <div class="coupon-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="会员手机号">
          <el-input v-model="filterForm.keyword" placeholder="会员手机号模糊查询" clearable style="width: 160px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="会员ID">
          <el-input v-model="filterForm.crm_id" placeholder="会员ID" clearable style="width: 110px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="券模板">
          <el-select v-model="filterForm.template_id" placeholder="全部模板" clearable filterable style="width: 180px;">
            <el-option v-for="t in templateOptions" :key="t.id" :label="t.name" :value="Number(t.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable style="width: 120px;">
            <el-option v-for="(label, value) in statusMap" :key="value" :label="label" :value="Number(value)" />
          </el-select>
        </el-form-item>
        <el-form-item label="来源">
          <el-select v-model="filterForm.source" placeholder="全部" clearable style="width: 140px;">
            <el-option label="注册自动发放" :value="1" />
            <el-option label="后台批量下发" :value="2" />
            <el-option label="活动领取" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="发放时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="couponList"
        height="60vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="coupon_no" label="券号" width="200" show-overflow-tooltip />
        <el-table-column label="会员" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.mem_user || '-' }}</div>
            <div class="sub-text">{{ scope.row.mem_name || ('ID:' + scope.row.crm_id) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="券名称" min-width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
            <el-tag size="mini" :type="Number(scope.row.type) === 1 ? 'warning' : 'success'" style="margin-left: 6px;">{{ scope.row.type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="面额" width="80" align="center">
          <template slot-scope="scope">¥{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column label="门槛" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.min_amount) > 0 ? scope.row.min_text : '无门槛' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="statusTagType(scope.row.status)">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="source_text" label="来源" width="110" align="center" />
        <el-table-column prop="valid_text" label="有效期" min-width="180" show-overflow-tooltip />
        <el-table-column prop="create_time" label="发放时间" width="160" />
        <el-table-column label="操作" width="130" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c;"
              :disabled="Number(scope.row.status) !== 0 && Number(scope.row.status) !== 1"
              @click="handleInvalid(scope.row)"
            >作废</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 券详情弹窗 -->
    <el-dialog title="优惠券详情" :visible.sync="detailVisible" width="640px">
      <div v-loading="detailLoading">
        <div class="detail-grid" v-if="detail">
          <div class="detail-item"><span class="label">券号</span><span class="value">{{ detail.coupon_no }}</span></div>
          <div class="detail-item"><span class="label">会员</span><span class="value">{{ detail.mem_user || '-' }} {{ detail.mem_name ? '(' + detail.mem_name + ')' : '' }}</span></div>
          <div class="detail-item"><span class="label">面额</span><span class="value price">¥{{ detail.amount }}</span></div>
          <div class="detail-item"><span class="label">门槛</span><span class="value">{{ Number(detail.min_amount) > 0 ? '满 ' + detail.min_amount + ' 元可用' : '无门槛' }}</span></div>
          <div class="detail-item"><span class="label">状态</span><span class="value"><el-tag size="small" :type="statusTagType(detail.status)">{{ detail.status_text }}</el-tag></span></div>
          <div class="detail-item"><span class="label">会员ID</span><span class="value">{{ detail.crm_id }}</span></div>
        </div>

        <h4 class="flow-title" v-if="detail && detail.flows && detail.flows.length">券流水（完整生命周期）</h4>
        <el-timeline v-if="detail && detail.flows && detail.flows.length">
          <el-timeline-item
            v-for="flow in detail.flows"
            :key="flow.id"
            :timestamp="flow.create_time"
            :type="flowTagType(flow.action)"
          >
            <div class="flow-line">
              <el-tag size="mini" :type="flowTagType(flow.action)">{{ flow.action_text }}</el-tag>
              <span class="flow-amount" v-if="flow.amount">¥{{ flow.amount }}</span>
              <span class="flow-operator">{{ flow.operator }}</span>
            </div>
            <div class="flow-remark" v-if="flow.remark">{{ flow.remark }}</div>
            <div class="flow-order" v-if="flow.order_dh">关联订单：{{ flow.order_dh }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { couponLists, couponDetail, couponInvalid, templateLists } from '@/api/coupon'

export default {
  name: 'CouponList',
  data () {
    return {
      loading: false,
      couponList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        crm_id: '',
        template_id: '',
        status: '',
        source: ''
      },
      dateRange: [],
      templateOptions: [],
      statusMap: {
        0: '未使用',
        1: '已锁定',
        2: '已使用',
        3: '已过期',
        4: '已失效'
      },
      // 详情弹窗
      detailVisible: false,
      detailLoading: false,
      detail: null
    }
  },
  mounted () {
    this.fetchTemplateOptions()
    this.fetchList()
  },
  methods: {
    statusTagType (status) {
      const map = { 0: 'success', 1: 'warning', 2: '', 3: 'info', 4: 'danger' }
      return map[Number(status)] ?? 'info'
    },

    flowTagType (action) {
      const map = { 1: 'success', 2: 'warning', 3: 'primary', 4: '', 5: 'primary', 6: 'danger', 7: 'info' }
      return map[Number(action)] ?? 'info'
    },

    async fetchTemplateOptions () {
      try {
        const res = await templateLists({ page: 1, page_size: 200 })
        if (res && String(res.code) === '0') {
          this.templateOptions = res.data || []
        }
      } catch (error) {
        console.error('获取券模板选项失败', error)
      }
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.crm_id) params.crm_id = this.filterForm.crm_id
        if (this.filterForm.template_id !== '' && this.filterForm.template_id !== null) params.template_id = this.filterForm.template_id
        if (this.filterForm.status !== '' && this.filterForm.status !== null) params.status = this.filterForm.status
        if (this.filterForm.source !== '' && this.filterForm.source !== null) params.source = this.filterForm.source
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_time = this.dateRange[0]
          params.end_time = this.dateRange[1]
        }
        const res = await couponLists(params)
        if (res && String(res.code) === '0') {
          this.couponList = res.data || []
          this.total = res.total || 0
        } else {
          this.couponList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取优惠券列表失败')
        }
      } catch (error) {
        console.error('获取优惠券列表失败', error)
        this.couponList = []
        this.total = 0
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', crm_id: '', template_id: '', status: '', source: '' }
      this.dateRange = []
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    async openDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      try {
        const res = await couponDetail({ id: row.id })
        if (res && String(res.code) === '0') {
          this.detail = res.data
        } else {
          this.$message.error(res && res.msg ? res.msg : '获取券详情失败')
        }
      } catch (error) {
        console.error('获取券详情失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.detailLoading = false
      }
    },

    async handleInvalid (row) {
      let reason = ''
      try {
        const value = await this.$prompt(`确定作废券「${row.name}」（${row.coupon_no}）吗？仅未使用/已锁定的券可作废。`, '作废优惠券', {
          confirmButtonText: '确定作废',
          cancelButtonText: '取消',
          type: 'warning',
          inputType: 'textarea',
          inputPlaceholder: '请输入作废原因（必填，将写入流水留痕）',
          inputValidator: (val) => (val && val.trim() ? true : '作废原因不能为空')
        })
        reason = value && value.value ? value.value.trim() : ''
      } catch (e) {
        return
      }
      if (!reason) return
      try {
        const res = await couponInvalid({ id: row.id, reason })
        if (res && String(res.code) === '0') {
          this.$message.success(res.message || '作废成功')
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '作废失败')
        }
      } catch (error) {
        console.error('作废失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .sub-text {
      color: #999;
      font-size: 12px;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}

.detail-grid {
  display: flex;
  flex-wrap: wrap;

  .detail-item {
    width: 50%;
    padding: 6px 0;
    font-size: 13px;

    .label {
      display: inline-block;
      width: 70px;
      color: #999;
    }

    .value {
      color: #303133;

      &.price {
        color: #f56c6c;
        font-weight: 600;
      }
    }
  }
}

.flow-title {
  margin: 18px 0 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.flow-line {
  .flow-amount {
    margin-left: 8px;
    color: #f56c6c;
    font-weight: 600;
  }

  .flow-operator {
    margin-left: 10px;
    color: #999;
    font-size: 12px;
  }
}

.flow-remark {
  margin-top: 4px;
  color: #606266;
  font-size: 13px;
}

.flow-order {
  margin-top: 2px;
  color: #909399;
  font-size: 12px;
}
</style>
